import React from "react";

export const MyAddressContext =
  React.createContext<any>(null);
